
export class HSLColor {
  H: number = 0;
  S: number = 0;
  L: number = 0;

  public toString = (): string => {

    return `hsl(${this.H}, ${this.S}%, ${this.L}%)`;
  }
}
